/**
 * Should the thread's scroll engine sit this growth out? A reader who scrolled up must not be
 * yanked down by an inbound message, BUT their own send always scrolls (they expect to see the
 * bubble they just sent). The first render always scrolls (opening a thread lands on the newest).
 */
export function holdsScroll(o: {
  isInitial: boolean;
  atBottom: boolean;
  isVisitorSend: boolean;
}): boolean {
  return !o.isInitial && !o.atBottom && !o.isVisitorSend;
}
